import { FC, HTMLProps } from 'react';
import s from './divider.module.css';
import cn from 'classnames';

interface Props extends HTMLProps<HTMLHRElement> {
  thickness?: string;
}

export const Divider: FC<Props> = (props) => {
  const { className, thickness, ...other } = props;

  return (
    <hr className={cn(s.component, className)} style={{ borderWidth: thickness }} {...other} />
  );
};
